"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("preact/jsx-runtime");
var preact_1 = require("preact");
var app_1 = __importDefault(require("./generator/app"));
var ab_testing_1 = require("./common/ab-testing");
var rootNode = document.getElementById('generator-app');
if (rootNode) {
    var showRating = rootNode.hasAttribute('data-show-rating') && rootNode.getAttribute('data-show-rating') !== 'false';
    var excludeFree = rootNode.hasAttribute('data-exclude-free') && rootNode.getAttribute('data-exclude-free') !== 'false';
    (0, preact_1.render)((0, jsx_runtime_1.jsx)(app_1.default, { showRating: showRating, excludeFree: excludeFree }), rootNode);
}
(0, ab_testing_1.cleanUpTests)();
